export enum ApiErrorCodes{
    PasswordResetTokenExpired = 1000,
    AccountVerificationTokenExpired = 1001
}